import { RuleId } from '@wix/a11y-rules';
import { useMemo } from 'react';
import { SITE_LEVEL_PAGE_ID } from '../../../../../consts';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useDomOrderRule } from '../../../../../rule-mappers/site-level-rules/dom-order/use-dom-order-rule';
import { useSiteLanguageRule } from '../../../../../rule-mappers/site-level-rules/use-site-language-rule';
import { useSkipToMainContentRule } from '../../../../../rule-mappers/site-level-rules/use-skip-to-main-content-rule';
import { useVisualIndicatorsRule } from '../../../../../rule-mappers/site-level-rules/use-visual-indicators-rule';
import { DISABLED_SITE_RULES, SITE_LEVEL_RULE_ORDER } from '../constants';
export const useSiteLevelRuleResults = () => {
  const {
    getGroupData
  } = usePanelStateAtom();
  const groupData = getGroupData(SITE_LEVEL_PAGE_ID);
  const {
    getDomOrderProps
  } = useDomOrderRule();
  const {
    getSiteLanguageProps
  } = useSiteLanguageRule();
  const {
    getSkipToMainContentProps
  } = useSkipToMainContentRule();
  const {
    getVisualIndicatorsProps
  } = useVisualIndicatorsRule();
  const ruleResults = useMemo(() => {
    if (!(groupData != null && groupData.ruleExecutionResults)) {
      return [];
    }
    const results = groupData.ruleExecutionResults.filter(result => !DISABLED_SITE_RULES.includes(result.ruleId)).map(result => {
      switch (result.ruleId) {
        case RuleId.VISUAL_INDICATORS:
          return getVisualIndicatorsProps({
            ruleExecutionResult: result
          });
        case RuleId.SKIP_TO_MAIN_CONTENT:
          return getSkipToMainContentProps({
            ruleExecutionResult: result
          });
        case RuleId.SITE_LANGUAGE:
          return getSiteLanguageProps({
            ruleExecutionResult: result
          });
        case RuleId.DOM_ORDER:
          return getDomOrderProps({
            ruleExecutionResult: result
          });
        default:
          return null;
      }
    }).filter(rule => rule !== null);
    const orderLookup = new Map(SITE_LEVEL_RULE_ORDER.map((id, index) => [id, index]));
    return [...results].sort((a, b) => (orderLookup.get(a.id) ?? Infinity) - (orderLookup.get(b.id) ?? Infinity));
  }, [groupData == null ? void 0 : groupData.ruleExecutionResults, getDomOrderProps, getSiteLanguageProps, getSkipToMainContentProps, getVisualIndicatorsProps]);
  return ruleResults;
};
//# sourceMappingURL=use-site-level-rule-results.js.map